import { render, staticRenderFns } from "./AccessChooser.vue?vue&type=template&id=eb8e60c8&scoped=true"
import script from "./AccessChooser.vue?vue&type=script&lang=js"
export * from "./AccessChooser.vue?vue&type=script&lang=js"
import style0 from "./AccessChooser.vue?vue&type=style&index=0&id=eb8e60c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8e60c8",
  null
  
)

export default component.exports